<template>
  <div class="page coupon-detail">
    <navigation>{{title}}</navigation>
    <div class="item">
      <div class="center">
        <span class="description" v-if="getPacketDescription">{{ getPacketDescription }}</span>
        <span class="title">
          {{item.couponType === 'LIMIT'?'专属':''}}{{ TopCardTitle }}
        </span>
        <span class="wapper">
          <span class="amount">
            {{ getDiscountValue }}
          </span>

          <span class="unit">
            {{ getPacketUnit }}
          </span>
        </span>
      </div>
      <div class="bottom">
        <template v-if="item.status === 'RECEIVED'&&item.activeType!=='XIAOMEI_VIP'">
          <span class="valid-time">
            {{ getValidTimeDesc }}
          </span>
          <span class="valid-time" v-if="useType">
            {{useType}}
          </span>
        </template>
        <template v-else>
          <span class="valid-time">
            {{ getValidTimeDesc }}
          </span>
          <span class="intrest-day">
            {{ getPacketIntrestDesc }}
          </span>
        </template>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="left-title">
          红包类型
        </div>
        <div class="right-title">
          {{ packetTypeName }}
        </div>
      </div>

      <div class="row" v-if="item.endTime && (!['RECEIVED', 'TIMEOUT', 'USED'].includes(item.status))">
        <div class="left-title">
          红包有效期
        </div>
        <div class="right-title">
          {{ item.endTime | date('YYYY-MM-DD') }}
        </div>
      </div>
      <div class="row">
        <div class="left-title">
          面额
        </div>
        <div class="right-title">
          <span class="amount">
            {{ getDiscountValue }}
          </span>

          <span class="unit">
            {{ getPacketUnit }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="left-title">
          用券说明
        </div>
        <div class="right-title">
        </div>
      </div>

      <div class="description" v-html="item.useDesc">
      </div>
    </div>

    <div class="footer">
      <nd-button class="btn" @click="usePacket" :disabled="item.status === 'USING' || item.status === 'USED' || item.checkResult === 'NOT'">
        {{ item.checkResult === 'NOT'? '不可使用优惠券': getButtonTitle  }}
      </nd-button>
    </div>

    <nd-dialog
      v-model="visiable"
      class="use-dialog"
      close-btn
      :footer="false"
    >
      <div class="dialog-content" :style="{ 'background-image': `url(${ item.useActionUrl })` }">
        <div class="dialog-footer">
          <nd-button class="btn" @click.stop="clickDialogAction">
            <span>{{ getDialogButtonTitle }}</span>
          </nd-button>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog
      v-model="visiableAmount"
      class="use-dialog"
      close-btn
      :footer="false"
    >
      <div class="dialog-content" :style="{ 'background-image': `url(${ item.useActionUrl })` }">
        <div class="title"><span>恭喜您，成功提现{{item.discountAmt|filterMoney}}元</span></div>
        <div class="content">
          <img src="./images/icon_hongbao.png" alt="">
          <p>红包金额将于5个工作日 <br>
            返现至您收款银行卡</p>
        </div>
        <div class="dialog-footer">
          <nd-button class="btn" @click.stop="clickDialogAction">
            <span>{{ getDialogButtonTitle }}</span>
          </nd-button>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog
      v-model="showInformation"
      class="use-dialog"
      close-btn
      :footer="false"
    >
      <div class="repayment">
        <div class="repayment-title"><span>{{item.usePopTitle}}</span></div>
        <p class="repayment-content">{{item.usePopContent}}</p>
        <div class="repayment-footer">
          <nd-button class="repayment-btn" @click.stop="clickDialogAction">
            <span>{{getDialogButtonTitle}}</span>
          </nd-button>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog
      v-model="ShowVipInformation"
      class="use-dialog"
      close-btn
      :footer="false"
    >
      <div class="information">
        <template v-if="['CREDIT','INFO','OCR'].includes(item.useAction)">
          <div class="information-title"><span>当前暂无额度 仅需3步，获得免息返现</span></div>
          <div class="information-content">
            <p>
              <span class="circle">1</span><span>获得授信额度</span>
            </p>
            <p>
              <span class="circle">2</span><span>完成1笔借款</span>
            </p>
            <p>
              <span class="circle">3</span><span>该订单倒数{{item.discountTermCount}}期正常还款</span>
            </p>
          </div>
        </template>
        <template v-else-if="item.useAction === 'LOAN'">
          <template v-if="this.item.activeType==='NEW_PERSON_V2'">
            <div class="information-title"><span>仅需2步，获得红包返现</span></div>
            <div class="information-content">
              <p class="information-content-one">
                <span class="circle">1</span><span>完成1笔借款</span>
              </p>
              <p class="information-content-two">
                <span class="circle">2</span><span>提现红包</span>
              </p>
            </div>
          </template>
          <template v-else>
            <div class="information-title"><span>还需2步，获得免息返现</span></div>
            <div class="information-content">
              <p class="information-content-one">
                <span class="circle">1</span><span>完成1笔借款</span>
              </p>
              <p class="information-content-two">
                <span class="circle">2</span><span>该订单倒数{{item.discountTermCount}}期正常还款</span>
              </p>
            </div>
          </template>
        </template>

        <template v-else>
          <div class="information-title"><span>还需一步，获得免息返现</span></div>
          <div class="information-content">
            <div class="center pd30 fz20">
              <span>该笔借据倒数{{item.discountTermCount}}期正常还款，返息金额将于还款后5个工作日内返现至您的收款卡</span>
            </div>
          </div>
        </template>
        <div class="information-footer">
          <nd-button class="btn" @click.stop="clickDialogAction">
            <span>{{getDialogButtonTitle}}</span><span class="pl8" v-if="time">({{time}}s)</span>
          </nd-button>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog v-model="dialogPreferential" closeBtn :footer="false">
      <div class="service-dialog3">
        <div class="description thick">您当前已有生效中的{{item.supportMemberGoodsName}}</div>
        <div class="description">您的会员权益生效中，</div>
        <div class="description">下次权益购买再使用优惠吧！</div>
        <div class="flex">
          <nd-button class="btn small" @click="find">查看我的权益</nd-button>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog v-model="dialog4" closeBtn :footer="false">
      <div class="service-dialog4">
        <div class="description">您当前如需使用权益功能，请更新至最新版本。 您可前往「天美贷-我的」点击「版本更新」进行升级。</div>
        <div class="flex">
          <nd-button class="btn small" @click="jumpHome">立即升级</nd-button>
        </div>
      </div>
    </nd-dialog>

    <nd-dialog
      v-model="ShowYZDInformation"
      class="use-dialog"
      close-btn
      :footer="false"
    >
      <div class="information">
        <div class="information-title"><span>还需1步，获得免息返现</span></div>
        <div class="information-content">
          <div class="center pd30 fz20">
            <span>完成颜值贷订单一笔还款，免息金额将于还款后5个工作日内返现至您的银行卡。</span>
          </div>
        </div>
        <div class="information-footer">
          <nd-button class="btn" @click.stop="goToYZDRepay">
            <span>去还款</span><span class="pl8" v-if="time">({{time}}s)</span>
          </nd-button>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { judgeClientSystem, getKey } from '../../assets/utils'
import { hasNativeMethod, jsBridge } from '../../assets/jsBridge'
import qs from 'qs'
import TicketsMaps from './tickets-map'

export default {
  name: 'quan-detail',
  customReadyNotify: true,
  data () {
    return {
      couponRecordId: this.$route.query.couponRecordId || '',
      visiable: false,
      visiableAmount: false, // 配置的金额展示
      item: {},
      COUNT_DOWN: 5,
      time: 0, //
      timer: null,
      showInformation: false,
      ShowVipInformation: false,
      dialogPreferential: false, // 是否已经购买权益
      isSvip: false, // 是否为svip
      vipType: '',
      dialog4: false, // 为了解决安卓页面兼容的问题，用户于老版本券包页面跳转及授信/提现结果页跳转进权益卡
      checkPendding: false,
      tipsDialog: false,
      path: {
        'FAC_M': '/privilege/credit/speed',
        'RAC_M': '/privilege/credit/retrial',
        'RWC_M': '/privilege/withdraw/retrial'
      },
      ShowYZDInformation: false // 显示颜值贷还款弹窗
    }
  },

  async created () {
    await this.getCouponDetail()
    await this.getLimitX({ loanPlatform: 'TMD' })
    this.$report({ id: 10002, args: { screen: this.item.activeType, visible: 1 } })
    this.$bus.$emit('ready')
  },
  destroyed () {
    this.$report({ id: 10002, args: { screen: this.item.activeType, visible: 0 } })
  },
  filters: {
    filterMoney (value) {
      if (value) {
        return Number(value).toFixed(2)
      } else {
        return '?'
      }
    }
  },
  computed: {

    ...mapState('user', {
      loanStatus: (state) => state.quotaInfo.loanStatus
    }),
    // 卡类型
    useType () {
      if (this.item.memberGoodsGroupCd) {
        return this.item.useLimitDesc
      } else {
        return ''
      }
    },
    getPacketDescription () {
      const { activeType, memberCouponDesc } = this.item
      return memberCouponDesc || TicketsMaps.PacketDescMap[activeType]
    },
    title () {
      return this.isCoupon ? '红包详情' : '优惠券'
    },
    TopCardTitle () {
      const { couponType, activeType, memberGoodsGroupCd, supportMemberGoodsName } = this.item
      // REDUCTION_INTEREST 实际现金红包 但是 要显示为免息红包
      if (couponType === 'COUPON' || activeType === 'REDUCTION_INTEREST' || activeType === 'PERSON_REPEAT_LOAN') {
        return '免息红包'
      } else if (couponType === 'CASH') {
        if (activeType === 'XIAOMEI_VIP') {
          return '拒就赔现金红包'
        } else {
          return '现金红包'
        }
      } else if (couponType === 'LIMIT') {
        return '提额券'
      } else if (couponType === 'RIGHTS_INTERESTS') {
        if (memberGoodsGroupCd === 'SVIP') {
          return 'SVIP优惠券'
        } else {
          return supportMemberGoodsName ? supportMemberGoodsName + '优惠券' : 'VIP优惠券'
        }
      } else if (couponType === 'REFUSE_PAY_PASSIVE') {
        return '现金红包'
      }
    },
    packetTypeName () {
      const { couponType, activeType, memberGoodsGroupCd, supportMemberGoodsName } = this.item
      // if (couponType === 'COUPON' || ['REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN'].includes(activeType)) {
      //   return '免息红包'
      // } else if (['CASH', 'REFUSE_PAY_PASSIVE'].includes(couponType)) {
      //   return '现金红包'
      // } else if (couponType === 'LIMIT') {
      //   return '提额券'
      // } else if (couponType === 'RIGHTS_INTERESTS') {
      //   return (memberGoodsGroupCd === 'SVIP' || supportMemberGoodsName) ? '优惠券' : 'VIP优惠券'
      // }
      // console.log(TicketsMaps.PacketTypeNameStrategies[couponType](activeType, memberGoodsGroupCd, supportMemberGoodsName))
      if (TicketsMaps.PacketTypeNameStrategies[couponType]) {
        return TicketsMaps.PacketTypeNameStrategies[couponType](activeType, memberGoodsGroupCd, supportMemberGoodsName)
      }
      return ''
    },
    getDiscountValue () {
      const { discountAmt, discountWay } = this.item
      if (discountAmt) {
        if (this.item.discountAmt <= 1 && discountWay === 'RATIO') {
          return (discountAmt * 10).toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
        } else {
          return Number(discountAmt).toFixed(2)
        }
      } else {
        return '?'
      }
    },

    getPacketUnit () {
      if (['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(this.item.activeType)) {
        return '元'
      } else if (this.item.discountAmt <= 1 && this.item.discountWay === 'RATIO') {
        return '折'
      } else {
        return `元`
      }
    },

    getValidTimeDesc () {
      const { activeType, endTime, couponType, memberGoodsGroupCd } = this.item
      if (!endTime) return ''
      if ((activeType === 'XIAOMEI_VIP' && ['CASH', 'REFUSE_PAY_PASSIVE'].includes(couponType)) || memberGoodsGroupCd === 'KING') {
        return `有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
      } else {
        return `红包激活有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
      }
    },

    getPacketIntrestDesc () {
      if (this.item.activeType === 'REDUCTION_INTEREST') {
        return `免息${this.item.discountValue}天`
      } else {
        return ''
      }
    },

    getButtonTitle () {
      const { couponType, status, activeType } = this.item
      this.$report({
        id: 10145,
        args: {
          activeType: activeType,
          couponRecordId: this.couponRecordId
        }
      })
      return TicketsMaps.ButtonTitleMap[couponType] ||
        TicketsMaps.ButtonTitleMap['OTHER'](status) ||
        TicketsMaps.ButtonTitleMap['DEFAULT']
    },

    getDialogButtonTitle () {
      return TicketsMaps.DialogButtonTitleStrategy(this.item)
    },
    // 当前是否是红包
    isCoupon () {
      // LIMIT: 额度券； RIGHTS_INTERESTS: 小美VIP优惠券
      return !['LIMIT', 'RIGHTS_INTERESTS', 'SVIP_RIGHTS_INTERESTS'].includes(this.item.couponType)
    },
    /// 是至尊王卡拒就赔红包
    isKingCardCoupon () {
      return this.item.memberGoodsGroupCd === 'KING' && this.item.couponType === 'REFUSE_PAY_PASSIVE'
    },
    /// 是至尊王卡优惠券
    isKingCardDiscountCoupon () {
      return this.item.memberGoodsGroupCd === 'KING' && this.item.couponType === 'RIGHTS_INTERESTS'
    }
  },

  watch: {
    visible (value) {
      this.$report({
        id: this.item.useAction === 'REPAY' ? 10148 : 10146,
        args: {
          visible: value ? 1 : 0,
          activeType: this.item.activeType,
          couponRecordId: this.couponRecordId
        }
      })
    },
    ShowVipInformation (value) {
      if (!value && this.timer) {
        clearInterval(this.timer)
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
      clearInterval(this.timer)
    })
  },
  methods: {

    ...mapActions('user', ['getLimitX']),

    ...mapActions('activities', [
      'couponDetailX',
      'useCouponX',
      'useRatingX',
      'useCheck'
    ]),
    ...mapActions('vip', ['vipInfo', 'memberInfo']),
    // 跳转首页
    jumpHome () {
      this.dialog4 = false
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      }
    },
    async getCouponDetail () {
      const res = await this.couponDetailX({
        couponRecordId: this.couponRecordId
      })
      if (res.success) {
        this.item = res.data || {}
      }
    },
    // 判断是新人和引流活动
    judge () {
      return (this.item.activeType === 'NEW_PERSON' || this.item.activeType === 'DRAINAGE' || this.item.activeType === 'NEW_PERSON_V2') && this.item.nextStep === 'LOAN_PASSED'
    },
    isShowDialog () {
      if (hasNativeMethod('getUserInfo') && judgeClientSystem() === 'Android' &&
        getKey('appVersion') && getKey('appVersion') < '1.7.4' && this.couponRecordId) {
          return true
      } else {
        return false
      }
    },
    // 处理卡类型
    dealSupportMemberGoodsCd (memberGoodsGroupCd, memberGoodsCd) {
      if (memberGoodsGroupCd === 'UNLIMITED') { // 卡种为不限
        if (memberGoodsCd === 'UC_U') { // 时间为不限 不限的时候取尊享版年卡 其它取尊享版当前卡
          memberGoodsCd = 'LC_M'
        } else {
          memberGoodsCd = memberGoodsCd.replace('U', 'L')
        }
      } else {
        if (memberGoodsCd.includes('EC')) {
          if (memberGoodsCd === 'EC_U') {
            memberGoodsCd = 'EC_M'
          } else {
            memberGoodsCd = memberGoodsCd.replace('U', 'E')
          }
        } else if (memberGoodsCd.includes('LC')) {
          if (memberGoodsCd === 'LC_U') {
            memberGoodsCd = 'LC_M'
          } else {
            memberGoodsCd = memberGoodsCd.replace('U', 'L')
          }
        }
      }
      return memberGoodsCd
    },
    jumpPrivilege (path) {
      const userInfo = getKey('userInfo')
      const channel = getKey('channel') || ''
      const url = `${process.env.VUE_APP_PAYURL}${path}?token=${userInfo.token}&channel=${channel}&refurl=${window.location.origin}`
      window.location.href = url
    },
    // 查看我的权益
    find () {
      this.dialogPreferential = false
      const origin = process.env.VUE_APP_PAYURL
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      if (['FAC_M', 'RAC_M', 'RWC_M'].includes(this.item.supportMemberGoodsCd)) {
        this.jumpPrivilege(this.path[this.item.supportMemberGoodsCd])
        return
      }
      if (this.isSvip) {
        window.location.href = `${origin}/vip/index?${qs.stringify({ couponRecordId: this.item.couponRecordId, target: 'svip', token, channel, refurl: window.location.origin, noExit: 'Y' })}`
      } else if (this.vipType === 'ENJOY') {
        window.location.href = `${origin}/vip/svip?${qs.stringify({ token, channel, refurl: window.location.origin })}`
      } else if (this.vipType === 'KING') {
        this.jumpToKingCardPage()
      } else {
        window.location.href = `${origin}/vip/lvip?${qs.stringify({ token, channel, refurl: window.location.origin })}`
      }
    },
    // 去还款界面
    goToYZDRepay () {
      const { productCode } = this.item || {}
      this.navigateTo({
        h5: `/repayment?type=${productCode}`
      })
    },
    // 点击按钮
    async  usePacket () {
      const { productCode, checkResult } = this.item || {}
      // 针对特权卡单独处理
      if (checkResult === 'HER') {
        this.dialogPreferential = true
        return
      }
      // 针对授信卡 加速卡的跳转单独处理
      if (['FAC_M', 'RAC_M', 'RWC_M'].includes(this.item.supportMemberGoodsCd)) {
        this.jumpPrivilege(this.path[this.item.supportMemberGoodsCd])
        return
      }
      if (productCode === 'YZD') {
        this.time = 5
        this.timer = setInterval(() => {
          if (this.time < 1) {
            this.goToYZDRepay()
            clearInterval(this.timer)
          } else {
            this.time--
          }
        }, 1000)
        this.ShowYZDInformation = true
      } else {
        const res = await this.memberInfo()
        this.$report({ id: 10187 })
        if (this.item.couponType === 'RIGHTS_INTERESTS') {
          // 优惠券使用
          if (this.item.memberGoodsGroupCd === 'SVIP') {
            if (res.success) {
              const { memberStatus, meetSVIP } = res.data || {}
              if (meetSVIP) {
                this.$router.push({ path: '/vip/index', query: { couponRecordId: this.item.couponRecordId, target: 'svip', noExit: 'Y' } })
              } else if (['NORMAL', 'FROZEN'].includes(memberStatus)) {
                this.isSvip = true
                this.dialogPreferential = true
              } else {
                this.$message('暂无使用资格')
              }
            }
          } else {
            const [ENJOY, LIGHT_ENJOY, KING] = await Promise.all([
              this.vipInfo({ memberGoodsGroupCd: 'ENJOY' }),
              this.vipInfo({ memberGoodsGroupCd: 'LIGHT_ENJOY' }),
              this.vipInfo({ memberGoodsGroupCd: 'KING' })
            ])

            if (ENJOY.success && LIGHT_ENJOY.success && KING.success) {
              if (ENJOY.data.myMemberInfo && ENJOY.data.myMemberInfo.memberStatus === 'NORMAL') {
                this.dialogPreferential = true
                this.vipType = 'ENJOY'
              } else if (LIGHT_ENJOY.data.myMemberInfo && LIGHT_ENJOY.data.myMemberInfo.memberStatus === 'NORMAL') {
                this.dialogPreferential = true
                this.vipType = 'LIGHT_ENJOY'
              } else if (KING.data.myMemberInfo && KING.data.myMemberInfo.memberStatus === 'NORMAL') {
                this.dialogPreferential = true
                this.vipType = 'KING'
              } else {
                if (this.isShowDialog()) {
                  this.dialog4 = true
                } else {
                  let { couponRecordId, memberGoodsGroupCd } = this.item || {}
                  let supportMemberGoodsCd = this.dealSupportMemberGoodsCd(memberGoodsGroupCd, this.item.supportMemberGoodsCd)
                  memberGoodsGroupCd = ['UNLIMITED'].includes(memberGoodsGroupCd) ? 'LIGHT_ENJOY' : memberGoodsGroupCd
                  const { memberStatus } = res.data || {}
                  if (['NORMAL', 'FROZEN'].includes(memberStatus)) {
                    this.isSvip = true
                    this.dialogPreferential = true
                  } else {
                    this.$router.push({ path: '/vip/index', query: { couponRecordId, findTarget: supportMemberGoodsCd, noExit: 'Y' } })
                    // this.$router.push({ path: '/vip/preindex', query: { supportMemberGoodsCd, couponRecordId, memberGoodsGroupCd } })
                  }
                }
              }
            }
          }
        } else if (this.item.useAction) {
          if (this.item.couponType === 'LIMIT') { // 提额券
            if (['LOANING', 'LOAN_AUDIT', 'LOAN_REFUSED', 'LOAN_LOCKED', 'LOAN_WAIT_VIP'].includes(this.item.nextStep)) {
              this.$router.push({ path: '/middle/limit' })
            } else if (['CREDIT_LOCKED', 'CREDIT_REVIEW', 'CREDIT_REFUSED', 'CREDIT', 'OCR', 'INFO'].includes(this.item.nextStep)) {
              this.toLimitMiddle()
            } else {
              this.goWithDraw()
            }
          } else if (['REPAYING'].includes(this.item.nextStep)) {
            this.navigateTo({
              h5: `/repayment/result?repayId=${this.item.repayId}&type=${this.item.type}`
            })
          } else if (['CREDIT_LOCKED', 'CREDIT_REVIEW', 'CREDIT_REFUSED'].includes(this.item.nextStep)) { // 授信中 授信封禁
            this.toLimitMiddle()
          } else if (['CREDIT', 'OCR', 'INFO'].includes(this.item.nextStep)) { // 未实名 未授信
            if (['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(this.item.activeType)) {
              this.toLimitMiddle()
            } else if (this.item.activeType === 'XIAOMEI_VIP') {
              this.time = 5
              this.timer = setInterval(() => {
                if (this.time < 1) {
                  this.clickDialogAction()
                  clearInterval(this.timer)
                } else {
                  this.time--
                }
              }, 1000)
              this.ShowVipInformation = true
            } else {
              this.showInformation = true
            }
          } else if (this.item.useAction === 'FINAL') {
            this.goActivitiesBank()
          } else {
            if (['LOANING', 'LOAN_WAIT_VIP', 'LOAN_AUDIT', 'LOAN_REFUSED', 'LOAN_LOCKED'].includes(this.item.nextStep)) {
              this.toLimitMiddle()
            } else if (this.judge()) {
              this.visiableAmount = true
            } else {
              if (this.isKingCardCoupon) {
                // 至尊王卡拒就赔红包
                this.useCoupon()
              } else if (['XIAOMEI_VIP', 'NEW_PERSON_V2'].includes(this.item.activeType)) {
                if (this.item.couponChannel === 'BENEFIT' && this.item.couponType === 'CASH') { // 权益卡距就陪现金红包弹出提示
                  this.visiableAmount = true
                } else {
                  this.time = 5
                  this.timer = setInterval(() => {
                    if (this.time < 1) {
                      this.clickDialogAction()
                      clearInterval(this.timer)
                    } else {
                      this.time--
                    }
                  }, 1000)
                  this.ShowVipInformation = true
                }
              } else if (['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(this.item.activeType)) {
                this.visiable = true
              } else {
                this.showInformation = true
              }
            }
          }
        } else {
          this.$message(this.item.usePopContent)
        }
      }
    },

    navigateTo (path) {
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },

    clickDialogAction () {
      if (this.item.activeType === 'XIAOMEI_VIP' && this.item.couponChannel === 'BENEFIT' && this.item.couponType === 'CASH') { // 权益卡距就陪现金红包直接收下
        this.visiableAmount = false
        this.useCoupon()
      } else if (['CREDIT', 'INFO', 'OCR'].includes(this.item.useAction)) {
        this.toLimitMiddle()
      } else if (this.item.useAction === 'REPAY') {
        this.judge() ? this.visiableAmount = false : this.visiable = false
        this.$report({
          id: 10149,
          args: {
            activeType: this.item.activeType,
            couponRecordId: this.couponRecordId
          }
        })
        this.goRepayment()
      } else if (this.item.useAction === 'REPAYING') {
        this.navigateTo({
          h5: `/repayment/result?repayId=${this.item.repayId}&type=${this.item.type}`
        })
      } else if (this.item.useAction === 'FINAL') {
        this.judge() ? this.visiableAmount = false : this.visiable = false
        this.goActivitiesBank()
      } else if (this.item.useAction === 'LOAN') {
        this.goWithDraw()
      } else if (this.item.useAction === 'LOAN_PASSED') {
        this.judge() ? this.visiableAmount = false : this.visiable = false
        this.useCoupon()
      }
    },

    // 使用红包
    async useCoupon () {
      await this.useCouponX({
        couponRecordId: this.couponRecordId
      })
      await this.getCouponDetail()
    },

    goWithDraw () {
      const couponSerialNos = (!['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(this.item.activeType)) || (['XIAOMEI_VIP'].includes(this.item.activeType) && ['CASH', 'COUPON'].includes(this.item.couponType)) ? { couponSerialNos: this.item.couponRecordId, couponType: this.item.couponType } : {}
      this.$router.push({ path: '/middle/limit', query: { ...couponSerialNos } })
    },
    toLimitMiddle () {
      this.$router.push({ path: '/middle/limit' })
    },
    // 废弃 2023年04月26日10:57:52
    goBa1seInfo () {
      let obj = {}
      if (this.item.nextStep === 'OCR') {
        obj = { path: '/authentication/id', native: 'ocr', exitCurrent: true }
      } else if (['CREDIT_LOCKED', 'CREDIT_REVIEW', 'CREDIT_REFUSED'].includes(this.item.nextStep)) {
        obj = { path: `/authentication/result?applyNo=${this.item.stepRelationId}` }
      } else {
        obj = { path: '/authentication/base', native: 'basic_info', exitCurrent: false }
      }
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS' && obj.native) {
        jsBridge('navigateTo', { path: obj.native, exitCurrent: obj.exitCurrent })
      } else {
        this.$router.push(obj.path)
      }
    },

    goRepayment () {
      let params = {
        loanPlatform: 'TMD',
        productCd: 'TMDP'
      }
      if (this.item.relationId && this.item.relationId.includes('|')) {
        let ids = this.item.relationId.split('|')
        if (ids.length > 1) {
          params.orderId = ids[1]
        }
      } else {
        params.orderId = this.item.relationId
      }
      this.$router.push({ path: '/repayment/detail', query: params })
    },

    goActivitiesBank () {
      this.$router.push(
        `/activities/band?couponRecordId=${this.item.couponRecordId}&plan=${this.item.couponDetailType}`
      )
    }
  }
}
</script>

<style lang='less' src="./style.less" ></style>
@import "../../assets/less/mixin.less";

  
